// src/channel-partners/adminChannelPartnerRequestsApi.ts
import { apiClient } from "@maat/api-base";
var adminChannelPartnerRequestsApi = {
  /**
   * The request log, newest first, ACROSS workspaces.
   *
   * Every filter narrows SERVER-side, `channelPartnerId` included — it is a
   * filter here rather than a resolved tenancy precisely because support is
   * handed a correlation id and not a workspace.
   */
  list: async (params) => apiClient.get("/main/api/admin/channel-partners/requests", { params }),
  /**
   * One request, with both redacted bodies. `404` past the retention window. Every
   * answer writes an audit row naming the operator, so fetch it once per open.
   */
  get: async (requestId) => apiClient.get(`/main/api/admin/channel-partners/requests/${encodeURIComponent(requestId)}`),
  /** The developer console's stats, for one developer or (no id) every developer. */
  stats: async (params) => apiClient.get("/main/api/admin/channel-partners/requests/stats", { params }),
  /** The developer console's series, scoped like `stats`. */
  series: async (params) => apiClient.get("/main/api/admin/channel-partners/requests/series", { params }),
  /** Developers ranked by failures (or volume) over one window. */
  byDeveloper: async (params) => apiClient.get("/main/api/admin/channel-partners/requests/by-developer", { params })
};

export {
  adminChannelPartnerRequestsApi
};
